import { ProcedureInstance } from "./procedureInstance";
import { ProcedureInstanceBaseParams, ProcedureInstanceBase, PROCEDURETYPE } from "./procedureInstanceBase";
import { ProcedureRun } from "./procedureRun";
import { ProcedureTemplateInstance as ProcedureTemplateInstance } from "./procedureTemplateInstance";


export class ProcedureInstanceBuilder {
  build(data: ProcedureInstanceBaseParams): ProcedureInstanceBase {
    switch (data.procedureType) {
      case PROCEDURETYPE.PROCEDURE:
        return new ProcedureInstance(data);
      case PROCEDURETYPE.TEMPLATE:
        return new ProcedureTemplateInstance(data);
      case PROCEDURETYPE.RUN:
        return new ProcedureRun(data);
      default:
        return new ProcedureInstanceBase(data);
    }
  }
}
